import Login from "./Login";
import React, { Component } from "react";
import firebase, { auth, provider, appsRef } from "./firebase";
import _ from "lodash";
import { withRouter } from "react-router-dom";

function parseQuery(queryString) {
  var query = {};
  var pairs = (queryString[0] === "?"
    ? queryString.substr(1)
    : queryString
  ).split("&");
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split("=");
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
  }
  return query;
}

class Auth extends Component {
  constructor(props) {
    super(props);

    this.appsRef = appsRef;

    this.state = {
      application: {
        content: {},
        schemas: [
          {
            page: 1,
            schema: { type: "object", title: "Loading" },
            uiSchema: {}
          }
        ]
      },
      authStatus: false,
      alertText: "",
      alertType: "primary",
      errorMessage: "",
      isApplicationOpen: false,
      status: "login"
    };

    this.addAlert = this.addAlert.bind(this);
    this.checkTimes = this.checkTimes.bind(this);
    this.facebookLogin = this.facebookLogin.bind(this);
    this.googleLogin = this.googleLogin.bind(this);
    this.logout = this.logout.bind(this);
    this.loginUser = this.loginUser.bind(this);
    this.registerUser = this.registerUser.bind(this);
    this.startResetPassword = this.startResetPassword.bind(this);
    this.finishResetPassword = this.finishResetPassword.bind(this);

    this.fetchApplication = this.fetchApplication.bind(this);
  }

  checkTimes() {
    let applicationData = this.state.application;
    let now = new Date().getTime();
    let newState = _.pick(this.state, ["isApplicationOpen", "errorMessage"]);
   
    if (
      "dateOpen" in applicationData &&
      applicationData.dateOpen.seconds * 1000 > now
    ) {
      newState = {
        isApplicationOpen: false,
        errorMessage: `This application will open at ${applicationData.dateOpen.toLocaleString()}.`
      };
    } else if (
      "dateClose" in applicationData &&
      applicationData.dateClose.seconds * 1000 < now
    ) {
      newState = {
        isApplicationOpen: false,
        errorMessage:
          "This application is closed and no further submissions will be taken."
      };
    } else if (
      "dateClose" in applicationData &&
      applicationData.dateClose.seconds * 1000 < now + 3600000
    ) {
      newState = {
        isApplicationOpen: true,
        errorMessage: "This application will close within an hour."
      };
    } else if (
      "dateClose" in applicationData &&
      applicationData.dateClose.seconds * 1000 < now + 86400000
    ) {
      newState = {
        isApplicationOpen: true,
        errorMessage: "This application will close within 24 hours."
      };
    } else {
      newState = {
        isApplicationOpen: true,
        errorMessage: ""
      };
    }

    if (
      this.state.isApplicationOpen !== newState.isApplicationOpen ||
      this.state.errorMessage !== newState.errorMessage
    ) {
      this.setState(newState);
    }

    setTimeout(this.checkTimes, 1000);
  }

  fetchApplication() {
    let slug = this.props.match.params.id;
    appsRef
      .where("slug", "==", slug)
      .get()
      .then(snapshot => {
        // console.log("snap", snapshot, snapshot.docs, snapshot.size);
        if (snapshot.docs.length > 0) {
          snapshot.docs.forEach(application => {
            this.appRef = application;
            // console.log("Document data:", application.data());
            let applicationData = application.data();
            this.setState({
              appID: application.id,
              application: applicationData
            });
            // this.fetchSubmission(application.id, this.props.userID);
            document.title = `Obama Foundation - ${application.data().name}`;
            this.checkTimes();
          });
        } else {
          console.log("No such application!");
        }
      })
      .catch(error => {
        console.log("Error getting application:", error);
        this.addAlert("danger", "Error getting application");
      });
  }

  addAlert(alertType, alertText) {
    this.setState({ alertType: alertType, alertText: alertText });
  }

  registerUser(e) {
    e.preventDefault();
    e.stopPropagation();

    const email = e.target.newEmail.value;
    const password = e.target.newPassword.value;

    let actionCodeSettings = {
      url: `https://apply.obama.org/${this.props.match.params.id}/`,
      handleCodeInApp: false
    };

    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(user => {
        firebase.auth().currentUser
          .sendEmailVerification(actionCodeSettings)
          .then(() => {
            this.addAlert(
              "info",
              `We just sent a confirmation email to ${email}`
            );
          })
          .catch(error => {
            this.addAlert("danger", error.message);
            console.log(error);
          });
      })
      .catch(error => {
        this.addAlert("danger", error.message);
        console.log(error);
      });
  }

  googleLogin() {
    auth.signInWithPopup(provider.google).catch(error => {
      console.log(error);
      this.addAlert("danger", error.message);
    });
  }

  facebookLogin() {
    auth.signInWithPopup(provider.facebook).catch(error => {
      console.log(error);
      this.addAlert("danger", error.message);
    });
  }

  loginUser(e) {
    e.preventDefault();
    e.stopPropagation();

    let email = e.target.email.value;
    let password = e.target.password.value;

    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .catch(error => {
        this.addAlert("danger", error.message);
      });
  }

  logout() {
    auth.signOut().then(() => {
      console.log("Signed out");
      this.setState({
        authStatus: false,
        user: null,
        userID: null
      });
    });
  }

  startResetPassword(email) {
    let actionCodeSettings = {
      url: `https://apply.obama.org/${this.props.match.params.id}/`,
      handleCodeInApp: false
    };

    firebase
      .auth()
      .sendPasswordResetEmail(email, actionCodeSettings)
      .then(() => {
        this.addAlert("info", `We just sent a confirmation email to ${email}`);
      })
      .catch(error => {
        this.addAlert("danger", error.message);
      });
  }

  finishResetPassword(newPassword) {
    let params = parseQuery(this.props.location.search);

    firebase
      .auth()
      .confirmPasswordReset(params.oobCode, newPassword)
      .then(resp => {
        window.location = params.continueUrl;
      })
      .catch(error => {
        console.error(error);
        this.addAlert("danger", error.message);
      });
  }

  componentWillMount() {
    if (this.props.mode === "account") {
      let params = parseQuery(this.props.location.search);
      console.log(params);
      if (params.mode === "verifyEmail") {
        firebase
          .auth()
          .applyActionCode(params.oobCode)
          .then(resp => {
            console.log("email verified");
            window.location = params.continueUrl;
          })
          .catch(error => {
            console.error(error);
            this.addAlert("danger", error.message);
          });
      } else if (params.mode === "resetPassword") {
        firebase
          .auth()
          .verifyPasswordResetCode(params.oobCode)
          .then(email => {
            this.setState({ status: "finish_password" });
          })
          .catch(error => {
            this.addAlert("danger", error.message);
          });
      }
    }
  }

  componentDidMount() {
    auth.onAuthStateChanged(user => {
      if (user && user.emailVerified) {
        let userData = _.pick(user, [
          "displayName",
          "email",
          "emailVerified",
          "isAnonymous",
          "photoURL",
          "providerId",
          "uid"
        ]);

        this.setState({
          alertText: "",
          authStatus: true,
          user: userData,
          userID: userData.uid
        });
      } else if (user) {
        this.setState({
          alertText: "Please check your inbox for a confirmation email."
        });
      } else if (this.state.authStatus) {
        this.setState({ authStatus: false });
      }
    });

    if (
      _.isUndefined(this.state.application.slug) &&
      this.props.mode !== "account"
    ) {
      this.fetchApplication();
    }
  }

  render() {
    let authFunctions = {
      alertText: this.state.alertText,
      alertType: this.state.alertType,
      appID: this.state.appID,
      application: this.state.application,
      authStatus: this.state.authStatus,
      content: this.state.application.content,
      errorMessage: this.state.errorMessage,
      facebookLogin: this.facebookLogin,
      finishResetPassword: this.finishResetPassword,
      googleLogin: this.googleLogin,
      history: this.props.history,
      isApplicationOpen: this.state.isApplicationOpen,
      loginUser: this.loginUser,
      logout: this.logout,
      match: this.props.match,
      mode: this.state.mode,
      registerUser: this.registerUser,
      startResetPassword: this.startResetPassword,
      status: this.state.status,
      user: this.state.user,
      userID: this.state.userID
    };

    // console.log("params", this.props.match.params);

    return this.state.authStatus ? (
      <div>{React.cloneElement(this.props.children, authFunctions)}</div>
    ) : (
      <Login {...authFunctions} />
    );
  }
}

export default withRouter(Auth);



// WEBPACK FOOTER //
// ./src/Auth.js